import {openPanelInModal} from '@Components/modal-container/modal-container-reducer';
import {MODALS_IDS} from '@Components/modal-container';
import type {CancelSubscriptionPanelProps} from '@Panels/cancel-subscription-panel/cancel-subscription-panel.types';

export const openCancelSubscriptionModal = (props?: CancelSubscriptionPanelProps): void => {
  window.PMW.redux.store.dispatch(
    openPanelInModal({
      modalId: MODALS_IDS.CANCEL_SUBCSRIPTION_MODAL,
      panelProps: props ?? {},
    })
  );
};
